import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';

const Adminchangepassword = ({ onClose,name  }) => {
  const { handleSubmit } = useForm();
  const [roolName, setRoolName] = useState('');
console.log("name",name)
  const onSubmit = async () => {
    const updatedValues = {
        userId:name.userId,
        password: roolName,
        passwordupdateDate: new Date().toISOString(), 
      };
      console.log('Submitted:', updatedValues);

      try {
        const response = await axios.put(
          `http://localhost:4000/update-user/${name.userId}`,
          updatedValues
        );
        console.log("User Updated:", response.data);
        onClose();
      } catch (error) {
        console.error("Error updating user:", error.response?.data || error.message);
        alert(error.response?.data?.error || "Failed to update user.");
      }

  };

  return (
    <div>
      <div className="modal fade show" aria-modal="true" role="dialog" style={{ display: 'block' }}>
        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create Role</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>

            <form id="formAuthentication" className="mb-3 p-2" onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-2">
                <label htmlFor="roolName" className="form-label">
                  Change Password <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="roolName"
                  placeholder="Enter New Password"
                  value={roolName}
                  onChange={(e) => setRoolName(e.target.value)}
                  autoFocus
                  required
                />
              </div>

              <div className="modal-footer">
                <button type="submit" className="btn btn-primary">Save</button>
              </div>
            </form>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Adminchangepassword;
